import InputText, * as IInputText from '@lib/components/InputText';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { INativeWindow } from '@lib/types';
import ErrorMessage from 'components/ErrorMessage';
import ListItem from 'components/ListItem';
import { SmsProps } from 'containers/Sms';
import * as React from 'react';
import './Sms.css';

export interface Info {
  key: string;
  value: string;
}


interface ISmsState {
  phoneNumber: string;
  groupApn: boolean;
  groupAction: boolean;
  groupQuery: boolean;
  groupThermostat: boolean;

}



class Sms extends React.Component<SmsProps, ISmsState> {

  public constructor(props: SmsProps) {
    super(props);
    let ph = '';
    const localStoreKey = 'phoneNumber' + this.props.deviceId;
    if (localStorage.getItem(localStoreKey) !== null && localStorage.getItem(localStoreKey) !== undefined) {
      ph = localStorage.getItem(localStoreKey)!;
    }
    this.state = { phoneNumber: ph, groupApn: false, groupAction: false, groupQuery: false, groupThermostat: false };
  }

  /**
   * Fired when user click on back button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    this.props.onGoHome();
  }

  public dummyClick(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  public onGroupClick(idGroup: number, event: React.MouseEvent<HTMLDivElement>) {
    if (idGroup === 0) {
      this.setState({ groupQuery: !this.state.groupQuery });
    } else if (idGroup === 1) {
      this.setState({ groupAction: !this.state.groupAction });
    } else if (idGroup === 2) {
      this.setState({ groupThermostat: !this.state.groupThermostat });
    } else if (idGroup === 3) {
      this.setState({ groupApn: !this.state.groupApn });
    }
  }

  public onChangePhone(obj: any, event: React.ChangeEvent<HTMLInputElement>) {
    let phoneNumber = event.currentTarget.value;
    if (phoneNumber === undefined || phoneNumber === null) {
      phoneNumber = '';
    }
    const localStoreKey = 'phoneNumber' + this.props.deviceId;
    localStorage.setItem(localStoreKey, phoneNumber);
    this.setState({ phoneNumber });
  }


  public render() {

    const i18n = this.props.i18n;

    const infosQuery: Info[] = [];
    const infosAction: Info[] = [];
    const infosThermostat: Info[] = [];
    const infosApn: Info[] = [];


    infosQuery.push({ key: this.props.i18n.Sms.temp1, value: 'TEMP1?' });
    infosQuery.push({ key: this.props.i18n.Sms.temp2, value: 'TEMP2?' });
    infosAction.push({ key: this.props.i18n.Sms.out1on, value: 'OUT1=1' });
    infosAction.push({ key: this.props.i18n.Sms.out1off, value: 'OUT1=0' });
    infosAction.push({ key: this.props.i18n.Sms.out2on, value: 'OUT2=1' });
    infosAction.push({ key: this.props.i18n.Sms.out2off, value: 'OUT2=0' });

    infosApn.push({ key: this.props.i18n.Sms.apnGet, value: 'APN?' });
    infosApn.push({ key: this.props.i18n.Sms.apnServer, value: 'GSMAPN=XXXX' });
    infosApn.push({ key: this.props.i18n.Sms.apnUser, value: 'GSMUSER=' });
    infosApn.push({ key: this.props.i18n.Sms.apnPassword, value: 'GSMPASS=' });
    infosApn.push({ key: this.props.i18n.Sms.apnConnect, value: 'CONNECT' });


    // Thermostat Mode and code 
    if (this.props.m1 === undefined || this.props.m1 === '' || this.props.m1 >= '0.3.9') {
      infosApn.push({ key: this.props.i18n.Sms.changePassword, value: 'CODE=1234' });
      infosThermostat.push({ key: this.props.i18n.Sms.thermostatMode, value: 'MODE1?' });
      infosThermostat.push({ key: this.props.i18n.Sms.thermostatDisable, value: 'MODE1=0' });
      infosThermostat.push({ key: this.props.i18n.Thermostat.title + ' ' + this.props.i18n.Thermostat.modeEco, value: 'MODE1=1' });
      infosThermostat.push({ key: this.props.i18n.Thermostat.title + ' ' + this.props.i18n.Thermostat.modeComfort, value: 'MODE1=2' });
      infosThermostat.push({ key: this.props.i18n.Thermostat.title + ' ' + this.props.i18n.Thermostat.modeFrost, value: 'MODE1=3' });
      infosThermostat.push({ key: this.props.i18n.Thermostat.title + ' ' + this.props.i18n.Thermostat.modePlanning, value: 'MODE1=4' });
    }

    // Input 
    if (this.props.m1 === undefined || this.props.m1 === '' || this.props.m1 >= '0.4.4') {
      infosQuery.push({ key: this.props.i18n.Sms.in1, value: 'IN1?' });
      infosQuery.push({ key: this.props.i18n.Sms.in2, value: 'IN2?' });
    }
    infosQuery.push({ key: this.props.i18n.Sms.info, value: 'INFO?' });

    const smsDelimiter = (window as INativeWindow).device!.platform === 'Android' ? '?' : '&';

    return (
      <div className="standardPage sms" >
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={i18n.Sms.title}
        />

        <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />

        <InputText maxLength={20} error={""} isError={false} icon={IInputText.ICO_PHONE} type="tel" required={true} name={i18n.Sms.phoneNumber} id="phoneNumber" value={this.state.phoneNumber} onChange={this.onChangePhone.bind(this, null)} />


        <div onClick={this.onGroupClick.bind(this, 0)} className={'cmdGroup fas ' + (this.state.groupQuery ? 'fa-minus-circle' : 'fa-plus-circle')}>
          <span>{this.props.i18n.Sms.groupQuery}</span>
        </div>
        {this.state.groupQuery &&
          <div id="infoListSms">
            {infosQuery.map((info: Info) => (
              <a key={info.key} href={'sms:' + this.state.phoneNumber + smsDelimiter + 'body=2580 ' + info.value}><ListItem title={info.key} detail={info.value} onClick={this.dummyClick} /></a>
            ))}
          </div>
        }

        <div onClick={this.onGroupClick.bind(this, 1)} className={'cmdGroup fas ' + (this.state.groupAction ? 'fa-minus-circle' : 'fa-plus-circle')}>
          <span>{this.props.i18n.Sms.groupAction}</span>
        </div>
        {this.state.groupAction &&
          <div id="infoListSms">
            {infosAction.map((info: Info) => (
              <a key={info.key} href={'sms:' + this.state.phoneNumber + smsDelimiter + 'body=2580 ' + info.value}><ListItem title={info.key} detail={info.value} onClick={this.dummyClick} /></a>
            ))}
          </div>
        }

        <div onClick={this.onGroupClick.bind(this, 2)} className={'cmdGroup fas ' + (this.state.groupThermostat ? 'fa-minus-circle' : 'fa-plus-circle')}>
          <span>{this.props.i18n.Sms.groupThermostat}</span>
        </div>
        {this.state.groupThermostat &&
          <div id="infoListSms">
            {infosThermostat.map((info: Info) => (
              <a key={info.key} href={'sms:' + this.state.phoneNumber + smsDelimiter + 'body=2580 ' + info.value}><ListItem title={info.key} detail={info.value} onClick={this.dummyClick} /></a>
            ))}
          </div>
        }

        <div onClick={this.onGroupClick.bind(this, 3)} className={'cmdGroup fas ' + (this.state.groupApn ? 'fa-minus-circle' : 'fa-plus-circle')}>
          <span>{this.props.i18n.Sms.groupApn}</span>
        </div>
        {this.state.groupApn &&
          <div id="infoListSms">
            {infosApn.map((info: Info) => (
              <a key={info.key} href={'sms:' + this.state.phoneNumber + smsDelimiter + 'body=2580 ' + info.value}><ListItem title={info.key} detail={info.value} onClick={this.dummyClick} /></a>
            ))}
          </div>
        }
      </div >

    );
  }
}

export default Sms;



// WEBPACK FOOTER //
// ./src/pages/Sms.tsx